import React from "react";
import { Users, Tag, BadgeDollarSign, Image } from "lucide-react";
import { CampaignItem } from "./index";
import { ProfileCardBase } from "./profile-card-base";

interface VilleCardProps {
  item: CampaignItem;
}

export function VilleCard({ item }: VilleCardProps) {
  const formatInhabitants = (inhabitants?: number) => {
    if (!inhabitants) return "N.C.";
    return `${inhabitants} habitants`;
  };

  const formatSectors = (sectors?: string[]) => {
    if (!sectors || sectors.length === 0) return "N.C.";
    return sectors.join(", ");
  };

  const formatAids = (aids?: string[]) => {
    if (!aids || aids.length === 0) return "N.C.";
    return aids.join(", ");
  };

  return (
    <ProfileCardBase
      name={item.name}
      logoUrl={item.logo_url}
      fallbackIcon={Image}
      profileId={item.id}
      profileType="Profile::Ville"
      userId={item.user_id}
      entity={item}
      items={[
        {
          icon: Users,
          label: "Zone de ch.",
          value: formatInhabitants(item.inhabitants),
        },
        {
          icon: Tag,
          label: "Secteurs recherchés",
          value: formatSectors(item.sectors),
          nullValue: !item.sectors || item.sectors.length === 0,
        },
        {
          icon: BadgeDollarSign,
          label: "Aides à l'installation",
          value: formatAids(item.installation_aids),
          nullValue:
            !item.installation_aids || item.installation_aids.length === 0,
        },
      ]}
    />
  );
}
